/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PaginationResponse } from './';
import {
    PaginationResponseFromJSON,
    PaginationResponseFromJSONTyped,
    PaginationResponseToJSON,
} from './';
import type { ProfileResponse } from './';
import {
    ProfileResponseFromJSON,
    ProfileResponseFromJSONTyped,
    ProfileResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchResponse
 */
export interface SearchResponse {
    /**
     * 
     * @type {string}
     * @memberof SearchResponse
     */
    searchId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResponse
     */
    searchType: SearchResponseSearchTypeEnum;
    /**
     * 
     * @type {Array<ProfileResponse>}
     * @memberof SearchResponse
     */
    profiles: Array<ProfileResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof SearchResponse
     */
    pagination: PaginationResponse;
    /**
     * 
     * @type {string}
     * @memberof SearchResponse
     */
    fallback?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResponse
     */
    query?: string;
}


/**
 * @export
 */
export const SearchResponseSearchTypeEnum = {
    GlobalDomain: 'GLOBAL_DOMAIN',
    Located: 'LOCATED',
    HostCountryRemote: 'HOST_COUNTRY_REMOTE',
    HostConfiguredCountriesRemote: 'HOST_CONFIGURED_COUNTRIES_REMOTE'
} as const;
export type SearchResponseSearchTypeEnum = typeof SearchResponseSearchTypeEnum[keyof typeof SearchResponseSearchTypeEnum];


/**
 * Check if a given object implements the SearchResponse interface.
 */
export function instanceOfSearchResponse(value: object): value is SearchResponse {
    if (!('searchId' in value) || value['searchId'] === undefined) return false;
    if (!('searchType' in value) || value['searchType'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function SearchResponseFromJSON(json: any): SearchResponse {
    return SearchResponseFromJSONTyped(json, false);
}

export function SearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'searchId': json['searchId'],
        'searchType': json['searchType'],
        'profiles': ((json['profiles'] as Array<any>).map(ProfileResponseFromJSON)),
        'pagination': PaginationResponseFromJSON(json['pagination']),
        'fallback': json['fallback'] == null ? undefined : json['fallback'],
        'query': json['query'] == null ? undefined : json['query'],
    };
}

export function SearchResponseToJSON(value?: SearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'searchId': value['searchId'],
        'searchType': value['searchType'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => ProfileResponseToJSON(v))),
        'pagination': PaginationResponseToJSON(value['pagination']),
        'fallback': value['fallback'],
        'query': value['query'],
    };
}

